import React from 'react'
import { Link, useLocation} from 'react-router-dom'
import jsPDF from 'jspdf'

const Navigation=()=> {
    const location=useLocation()

	// pdf generate 
	const generatePdf = async ()=>{

		let elem=document.getElementById('cv-a4')
		if(elem){
			const rect = elem.getBoundingClientRect();
			const doc = new jsPDF({
			  unit: 'px',
			  format: [rect.width, rect.height + 10]
			}); 
			
			doc.html(elem, {
			 callback: function (doc) {
			   doc.save();
			 }
		  });
		}

	}	
    return (
        <div className='home__navigation'>			
				<div className="home__navigation-tabs">
						<div className="home__navigation-tabs-tab tab">							
						<Link to="/left" className={location.pathname==='/left'?'active-tab':''}> Left side</Link>
						<Link to="/right" className={location.pathname==='/right'?'active-tab':''}> Right side</Link>
						<Link to="/branding" className={location.pathname==='/branding'?'active-tab':''}> Branding </Link>							
						</div>
				</div>
				<div className="home__navigation-actions">
					<Link to="/preview"><div className="btn btn__primary-outline">Preview</div></Link>					
					<div className="btn btn__primary" onClick={generatePdf}>Export</div>
				</div>

			</div>
    )
}

export default Navigation
